<template>
    <div
        v-if="unit"
        :class="compact ? 'doc-panel-compact' : 'doc-panel'"
    >
        <div
            class      = "v-flex mb-0 white"
            @dragover  = "onDragover"
            @dragleave = "onDragleave"
            @drop      = "onDrop"
        >
            <div style="display: block" >
                <div class="pt-3 doc-header v-flex">
                    <div>
                        {{ $t("dms.upload.title") }}
                    </div>
                    <v-switch
                        v-if    = "!compact"
                        v-model = "all"
                        style   = "margin-top: 1px;"
                        :label  = "all ? $t('dms.assign.all') : $t('dms.assign.unit', [ unit.fabricNo ])"
                        class   = "pt-0 ml-2"
                        :ripple = "false"
                        @change = "onAll"
                        hide-details
                    />
                </div>
                <div class="step-name">
                    {{ stepName}}
                </div>
            </div>

            <v-spacer />
            <div class="mt-1">
                <input
                    v-model = "search"
                    class   = "lm-border search-field"
                    @input  = "onSearch"
                />
            </div>
            <div class="text-center mt-3 mr-3 ml-2">
                <v-icon class="primary--text" size="32">mdi-cloud-upload</v-icon>
            </div>
        </div>

        <div v-if="isDragging" class="w-100 text-center primary--text">
            {{ $t("dms.upload.mousehint") }}
        </div>

        <div :class="compact ? 'doc-panel-compact' : 'doc-panel'">
            <p-dms-entries
                :step-data-id = stepDataId
                :category     = "category"
                :documents    = "documents"
                :compact      = "compact"
            />
        </div>
    </div>
</template>

<script>

import PDmsEntries from "@/modules/dms/menu/components/private/PDmsEntries.vue";
import Inc from "@/modules/inc/service/Inc";
import Dms from "@/modules/dms/common/service/Dms";
import Core from "@/modules/core/service/Core";

export default {
    name: "CDmsDocuments",

    components: {
        PDmsEntries,
    },

    props: {
        category: {

        },

        documents: {

        },

        stepDataId: {

        },

        bidId: {
            required: false,
            type    : Number,
            default : () => {
                return null;
            }
        },

        stepName: {

        },

        compact: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        }
    },

    data: () => ({
        menu      : false,
        count     : null,
        isDragging: false,
        search    : null,
        all       : true
    }),

    computed: {
        unit () {
            return this.$store.getters.site;
        },
    },

    watch: {
        menu () {
            this.$emit("menu", this.menu);
        },
    },

    methods: {
        onSelected (document) {
            this.$emit("selected", document);
        },

        onDragover (e) {
            e.preventDefault();
            this.isDragging = true;
        },

        onDragleave (e) {
            e.preventDefault();
            this.isDragging = false;
        },

        onDrop (e) {
            e.preventDefault();
            const files = e.dataTransfer.files;
            Inc.document.upload (this, this.stepDataId, this.bidId, this.all ? null : this.unit.id, files).then((data) => {
                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : this.stepDataId,
                    documents: data
                });

                Core.message.hint(this, this.$t("dms.entry.message.uploaded"));
            });

            this.isDragging = false;
        },

        onAll () {
            this.$emit("context", this.all);
        },

        onSearch () {
            this.$emit("search", this.search);
        }
    }
}
</script>

<style scoped>

.step-icon i {
    font-size: 20px;
}

.doc-panel {
    width: 530px;
    background-color: white;
}

.doc-panel-compact {
    width: calc(100% - -4px);
    background-color: white;
}

.doc-header {
    font-size: 18px;
    font-weight: 600;
    max-width: 490px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.step-name {
    font-size: 11px;
    margin-top: -4px;
}

.search-field {
    margin-top: 8px !important;
    padding-top: 3px!important;
    padding-bottom: 3px;
    padding-left: 4px;
    padding-right: 4px;
    font-size: 14px;
}

</style>